import styled from '@emotion/styled'
import { Grid } from '@mui/material'
import React from 'react'
import { P } from '../../../Styles/style'

const CardWrapper = styled.div`
    padding: 25px;
`
const CardHeading = styled.h3`
    color: ${ (props) => props.theme.textPrimary};
    position: relative;
    z-index: 1;
    font-size: 50px;
    padding: 0 7px;
    line-height: 1;
    margin: 30px 0;

    span{
        font-size: 17px;
        background-color: rgba(255, 164, 9, 0.5);
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        padding: 4px 10px 4px 75px;
        border: 1px solid rgba(255, 164, 9, 0.5);
        border-radius: 6px;
        height: 32px;
        display: flex;
        align-items: center;
        color: #FFA409;
        font-weight: 300;
    }
`
const WorksCard = (props) => {
  return (
    <Grid xs={12} sm={6} md={4}>
        <CardWrapper>
            <CardHeading>{props.step}<span>{props.title}</span></CardHeading>
            <P>{props.discription}</P>
        </CardWrapper>
    </Grid>
  )
}

export default WorksCard